(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["silicone-mat-enhancements"]) return;
  try {
    
(() => {
  const setupStickyBuy = (container) => {
    if (container.dataset.siliconeStickyEnhanced === 'true') return;
    container.dataset.siliconeStickyEnhanced = 'true';

    const stickyBar = container.querySelector('[data-sticky-buy]');
    const addButton = container.querySelector('[data-add-to-cart]');
    if (!stickyBar || !addButton) return;

    const updateStickyVisibility = () => {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const rect = addButton.getBoundingClientRect();
      stickyBar.classList.toggle('is-visible', isMobile && rect.bottom < 0);
    };

    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility, { passive: true });
    updateStickyVisibility();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-silicone-product]').forEach(setupStickyBuy);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silicone-mat-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const getSelectedOptions = (groups) => groups.map((group) => {
    const checked = group.querySelector('input:checked');
    return checked ? checked.value : '';
  });

  const optionsMatch = (variantOptions, selectedOptions) => {
    return variantOptions.every((option, index) => option === selectedOptions[index]);
  };

  const initQuantity = (container) => {
    container.querySelectorAll('[data-quantity]').forEach((wrapper) => {
      if (wrapper.dataset.quantityReady === 'true') return;
      wrapper.dataset.quantityReady = 'true';
      const input = wrapper.querySelector('input');
      wrapper.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', () => {
          const delta = button.dataset.action === 'increase' ? 1 : -1;
          const next = Math.max(1, Number(input.value || 1) + delta);
          input.value = String(next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  };

  const initGallery = (container) => {
    const gallery = container.querySelector('[data-gallery]');
    if (!gallery) return;
    const items = Array.from(gallery.querySelectorAll('[data-media-id]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-media-target]'));

    const activate = (mediaId) => {
      const target = items.find((item) => item.dataset.mediaId === String(mediaId));
      if (!target) return;
      items.forEach((item) => {
        const active = item === target;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
      });
      thumbs.forEach((thumb) => {
        const active = thumb.dataset.mediaTarget === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => activate(thumb.dataset.mediaTarget));
    });

    container.siliconeActivateMedia = activate;
  };

  const initZoom = (container) => {
    const dialog = container.querySelector('[data-zoom-dialog]');
    const frame = container.querySelector('[data-zoom-frame]');
    if (!dialog || !frame) return;

    container.querySelectorAll('[data-gallery-zoom]').forEach((button) => {
      button.addEventListener('click', () => {
        const image = button.querySelector('img');
        if (!image) return;
        frame.innerHTML = '';
        const largeImage = document.createElement('img');
        largeImage.src = image.currentSrc || image.src;
        largeImage.alt = image.alt || '';
        frame.appendChild(largeImage);
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    });

    container.querySelector('[data-zoom-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  };

  const initProduct = (container) => {
    if (container.dataset.siliconeReady === 'true') return;
    container.dataset.siliconeReady = 'true';

    const form = container.querySelector('.silicone-product__form');
    const variantsNode = container.querySelector('[data-variants-json]');
    if (!form || !variantsNode) return;

    const variants = JSON.parse(variantsNode.textContent || '[]');
    const groups = Array.from(container.querySelectorAll('[data-option-group]'));
    const idInput = container.querySelector('[data-variant-id]');
    const price = container.querySelector('[data-price]');
    const compare = container.querySelector('[data-compare]');
    const stock = container.querySelector('[data-stock]');
    const addButton = container.querySelector('[data-add-to-cart]');
    const stickyAdd = container.querySelector('[data-sticky-add]');
    const addText = container.querySelector('[data-add-text]');
    const summary = container.querySelector('[data-selected-summary]');
    const stickyPrice = container.querySelector('[data-sticky-price]');
    const stickySummary = container.querySelector('[data-sticky-summary]');
    const message = container.querySelector('[data-form-message]');

    const findVariant = () => {
      const selected = getSelectedOptions(groups);
      if (!selected.length) return variants[0];
      return variants.find((variant) => optionsMatch(variant.options, selected));
    };

    const optionAvailable = (groupIndex, value) => {
      const selected = getSelectedOptions(groups);
      selected[groupIndex] = value;
      return variants.some((variant) => variant.available && optionsMatch(variant.options, selected));
    };

    const setMessage = (text, isError = false) => {
      if (!message) return;
      message.textContent = text;
      message.hidden = !text;
      message.classList.toggle('is-error', isError);
    };

    const updateOptionStates = () => {
      groups.forEach((group, groupIndex) => {
        group.querySelectorAll('input').forEach((input) => {
          input.disabled = !optionAvailable(groupIndex, input.value);
        });
      });
    };

    const update = () => {
      const variant = findVariant();
      const selected = getSelectedOptions(groups);

      groups.forEach((group, index) => {
        const selectedLabel = group.querySelector(`[data-selected-option="${index}"]`);
        if (selectedLabel) selectedLabel.textContent = selected[index] || '';
      });

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (stickyAdd) stickyAdd.disabled = true;
        if (addText) addText.textContent = container.dataset.unavailableText;
        if (stock) {
          stock.textContent = container.dataset.unavailableText;
          stock.classList.add('is-sold-out');
        }
        if (summary) summary.textContent = selected.filter(Boolean).join(' / ');
        if (stickySummary) stickySummary.textContent = selected.filter(Boolean).join(' / ');
        updateOptionStates();
        return;
      }

      idInput.value = String(variant.id);
      if (price) price.textContent = variant.priceText;
      if (stickyPrice) stickyPrice.textContent = variant.priceText;

      if (compare) {
        compare.textContent = variant.compareAtPriceText || '';
        compare.hidden = !variant.compareAtPriceText;
      }

      if (summary) summary.textContent = variant.title;
      if (stickySummary) stickySummary.textContent = variant.title;

      if (stock) {
        stock.textContent = variant.available ? container.dataset.inStockText : container.dataset.soldOutText;
        stock.classList.toggle('is-sold-out', !variant.available);
      }

      if (addButton) addButton.disabled = !variant.available;
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? container.dataset.addText : container.dataset.soldOutText;
      if (stickyAdd) stickyAdd.textContent = variant.available ? container.dataset.addText : container.dataset.soldOutText;

      if (variant.featuredMediaId && container.siliconeActivateMedia) {
        container.siliconeActivateMedia(variant.featuredMediaId);
      }

      if (window.history?.replaceState && container.dataset.productUrl) {
        const url = new URL(container.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      }

      updateOptionStates();
    };

    groups.forEach((group) => {
      group.querySelectorAll('input').forEach((input) => {
        input.addEventListener('change', () => {
          setMessage('');
          update();
        });
      });
    });

    stickyAdd?.addEventListener('click', () => addButton?.click());

    form.addEventListener('submit', async (event) => {
      if (!event.submitter || !event.submitter.matches('[data-add-to-cart]')) return;
      event.preventDefault();
      setMessage('');

      if (addButton?.disabled) return;
      addButton.disabled = true;
      if (stickyAdd) stickyAdd.disabled = true;

      try {
        const response = await fetch(container.dataset.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) throw new Error('cart_add_failed');

        const cartResponse = await fetch(container.dataset.cartJsonUrl, {
          headers: { Accept: 'application/json' }
        });
        const cart = await cartResponse.json();
        document.querySelectorAll('.cart-pill span').forEach((node) => {
          node.textContent = String(cart.item_count);
        });
        setMessage(container.dataset.addedText);
      } catch (error) {
        setMessage(container.dataset.errorText, true);
      } finally {
        update();
      }
    });

    initQuantity(container);
    initGallery(container);
    initZoom(container);
    update();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-silicone-product]').forEach(initProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
